<template>
  <div>
    <el-upload
      ref="uploadRef"
      :action="actionUrl"
      :accept="acceptType"
      :before-upload="beforeUpload"
      :limit="limitNum"
      :on-success="handleSuccess"
      :on-remove="handleRemove"
      :on-preview="handlePreview"
      :on-change="handleChange"
      :data="uploadFilesData"
      :headers="headers"
      :file-list="realFileList"
      :on-exceed="handleExceed"
      :class="{ 'upload-wrap': true, 'is-disabled': isDisabled }"
    >
      <el-button :disabled="isDisabled" size="small" type="primary"> {{ buttonText }} </el-button>
    </el-upload>
    <p>
      <span v-if="limitNum">{{ '允许上传' + limitNum + '个文件' }}，</span>
      <span>{{ '允许上传的格式：' + acceptType }}，</span>
      <span>{{ '文件大小不能超过' + maxSize + 'MB' }}</span>
    </p>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'
import { Loading } from 'element-ui'

export default {
  name: 'MyUpload',
  props: {
    actionUrl: {
      type: String,
      default: `${process.env.VUE_APP_GATEWAY || ''}/student-api/v1/upload/`,
      required: false
    },
    acceptType: {
      type: String,
      default: '*'
    },
    maxSize: {
      type: Number,
      default: 10
    },
    limitNum: {
      type: Number,
      default: 1
    },
    fileList: {
      type: Array,
      default: () => []
    },
    isDisabled: {
      type: Boolean
    },
    customFileName: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: '点击上传'
    },
    extendUpdata: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      headers: {
        Authorization: getToken()
      },
      realFileList: [],
      acceptList: [],
      isloading: null,
      fileName: '',
      uploadFilesData: {
        type: 'file',
        path: 1
      }
    }
  },

  mounted() {
    this.realFileList = this.fileList
    this.acceptList = this.acceptType.split(',')
  },
  methods: {
    handleChange(files) {
      this.uploadFilesData.name = files.name.substring(0, files.name.lastIndexOf('.'))
      for (const key in this.extendUpdata) {
        if (Object.prototype.hasOwnProperty.call(this.extendUpdata, key)) {
          this.uploadFilesData[key] = this.extendUpdata[key]
        }
      }
      this.isloading = Loading.service({
        lock: true,
        text: '文件上传中',
        customClass: 'loading-custom-class',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)'
      })
    },
    handlePreview(file) {
      const url = file.url || file.response.data.path
      const previewUrl = process.env.VUE_APP_HOST_URL + (process.env.VUE_APP_GATEWAY || '') + url
      if (url.indexOf('.doc') > 0 || url.indexOf('.docx') > 0) {
        window.open(previewUrl)
      } else {
        window.open(previewUrl)
      }
    },
    handleExceed(files, fileList) {
      this.$message.error(`目前只支持上传${this.limitNum}个文件， 请删除后再次选择！`, 'error')
    },
    getRealFileList(data) {
      this.realFileList = data
    },
    clearRealFileList() {
      this.realFileList = []
    },
    beforeUpload(file) {
      const isLtMaxSize = file.size / 1024 / 1024 < this.maxSize
      const isAcceptType = this.checkFileType(file)

      const isAcceptLimit = this.realFileList?.length <= this.limitNum
      if (!isLtMaxSize) {
        this.$message.error(`上传文件大小不能超过${this.maxSize}MB`)
        this.$nextTick(() => {
          this.isloading.close()
        })
        return false
      }
      if (!isAcceptType) {
        this.$message.error(`上传文件格式不正确，支持的格式为${this.acceptList.join(', ')}`)
        this.$nextTick(() => {
          this.isloading.close()
        })
        return false
      }
      if (!isAcceptLimit) {
        this.$message.error(`只允许上传${this.limitNum}个文件`)
        this.$nextTick(() => {
          this.isloading.close()
        })
        return false
      }
      return true
    },
    handleSuccess(response, file, fileList) {
      this.$nextTick(() => {
        this.isloading.close()
      })

      if (+response.code === 200) {
        this.$message.success('上传成功')
        this.realFileList.push({ ...file, url: response.data.path, name: this.customFileName ? this.customFileName + '.' + file.name.split('.').pop().toLowerCase() : file.name })
      } else {
        // 上传失败 删除本次长传的文件
        fileList.forEach((item, index) => {
          if (item.uid === file.uid) {
            fileList.splice(index, 1)
          }
        })
        // fileList
        this.$message.error(response.msg)
        return false
      }
    },
    handleRemove(file, uploadFiles) {
      if (file && file.status === 'success') {
        this.realFileList.forEach((item, index) => {
          if (item.uid === file.uid) {
            this.realFileList.splice(index, 1)
          }
        })

        this.$forceUpdate()
      }
    },

    checkFileType(file) {
      const fileType = '.' + file.name.split('.').pop().toLowerCase()
      return this.acceptList.includes(fileType)
    }
  }
}
</script>
<style lang="scss">
.el-upload-list--text {
  li {
    background: #e2c59814;
    padding: 9px;

    .el-icon-close {
      right: 10px;
      top: 15px;
    }

    .el-upload-list__item-status-label {
      right: 10px;
      top: 10px;
    }
  }

  li + li {
    margin-top: 5px;
  }
}

.upload-wrap {
  &.is-disabled {
    .el-upload-list__item {
      .el-icon-close {
        display: none;
      }
    }
  }
}
</style>
